import React from "react";
import { Box, Typography } from "@mui/material";
import { MessageBubbleContainer, MessageContent } from "./SharedStyledComponents";

const PaymentRequestBillMessage = ({
  message,
  isOwn,
  currentUser,
  storedUserId,
  onOpenPaymentDialog,
  getReadReceiptStatus,
  formattedMessage,
  isCurrentUserOwnerOrTeamMember,
  conversationInfo,
  wrappedOnOpenPaymentDialog,
}) => {
  const currentUserId = currentUser?.userId ?? storedUserId;

  const isUserInInitiationFor =
    message?.initiationFor?.includes(currentUserId);

  let isCurrentUserOwnerOrTeamMemberForThisOrder = false;
  if (message?.orderId?.businessId && isCurrentUserOwnerOrTeamMember) {
    const isSameBusiness =
      conversationInfo?.businessId === message?.orderId?.businessId;

    const isSameLocation =
      conversationInfo?.businessLocationId?._id ===
      message?.orderId?.locationId;

    isCurrentUserOwnerOrTeamMemberForThisOrder = Boolean(
      isSameBusiness || isSameLocation
    );
  }

  if (isCurrentUserOwnerOrTeamMemberForThisOrder && !isUserInInitiationFor) {
    return null;
  }

  const orderId = message?.orderId;
  const upfrontPercentage = orderId?.paymentSettings?.upfrontPercentage || 0;
  const isPaymentCompleted = orderId?.paymentCompleted === true;
  const customMessageText = formattedMessage.text;

  return (
    <MessageBubbleContainer isOwn={isOwn}>
      {!isOwn && (
        <Typography
          variant="body2"
          sx={{
            color: "#6b7280",
            fontSize: "14px",
            fontWeight: 500,
            marginBottom: 1,
          }}
        >
          {message?.senderId?.fullName ||
            message?.senderId?.userName ||
            "Someone"}
        </Typography>
      )}

      <MessageContent
        isOwn={isOwn}
        isTemp={message.isTemp}
        isPayment={true}
        isDisabled={false}
        onClick={() => {
          if (message?.orderId?._id && !isPaymentCompleted) {
            wrappedOnOpenPaymentDialog(message);
          }
        }}
        sx={{
          cursor: onOpenPaymentDialog && !isPaymentCompleted ? "pointer" : "default",
          "&:hover": {
            opacity: onOpenPaymentDialog && !isPaymentCompleted ? 0.9 : 1,
          },
        }}
      >
        <Box>
          <Box
            sx={{
              color: isOwn ? "#FFFFFF" : "#000000",
              fontSize: "16px",
              fontWeight: 600,
              lineHeight: 1.3,
              textAlign: "left",
              marginBottom: 2,
            }}
          >
            {customMessageText && customMessageText.includes("tip here") ? (
              <>
                {customMessageText.split("tip here")[0]}
                <Box
                  component="span"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (message?.orderId?._id && !isPaymentCompleted) {
                      onOpenPaymentDialog?.(message);
                    }
                  }}
                  sx={{
                    color: isPaymentCompleted ? "#9CA3AF" : (isOwn ? "#FDE047" : "#7C3AED"),
                    textDecoration: isPaymentCompleted ? "none" : "underline",
                    cursor: isPaymentCompleted ? "not-allowed" : "pointer",
                    opacity: isPaymentCompleted ? 0.6 : 1,
                    "&:hover": {
                      color: isPaymentCompleted ? "#9CA3AF" : (isOwn ? "#FEF08A" : "#6D28D9"),
                      textDecoration: isPaymentCompleted ? "none" : "underline",
                    },
                  }}
                >
                  tip here
                </Box>
                {customMessageText.split("tip here")[1]}
              </>
            ) : (
              customMessageText ||
              (upfrontPercentage > 0
                ? `thank you for your patronage! ${upfrontPercentage}% upfront has been requested for your order. please make payment or add a tip here.`
                : "your bill is ready. please make payment or add a tip here.")
            )}
          </Box>
        </Box>
      </MessageContent>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isOwn ? "flex-end" : "flex-start",
          gap: 1,
          marginTop: 0.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "#9ca3af",
            fontSize: "12px",
          }}
        >
          {message.timestamp || "now"}
        </Typography>
        {isOwn && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {getReadReceiptStatus()}
          </Box>
        )}
      </Box>
    </MessageBubbleContainer>
  );
};

export default PaymentRequestBillMessage;
